export enum ScheSortableColumns {
	DATE_BEGIN = "date_begin"
}